export enum sizes {
  small = "480",
  medium = "960",
  large = "1920",
}

export const buildUri = (url: string, size: sizes) => {
  if (String(url).includes("{.width}")) {
    return url.replace("{.width}", `.${size}`);
  }

  return url;
};
